module.exports = __webpack_public_path__ + "static/media/safepal-wallet.f70fc3d8.svg";